import { RestSlice } from '../../../../redux/rest.slice';
import { CccCompany } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const cccCompanySlice = new RestSlice<CccCompany>(
	localizationService.getLocalizedString('cccCompany.companies'),
	Resource.CccCompanies
);
export default cccCompanySlice.rests.reducer;
